<template>
    <div  :style="style">
      <h1 style="text-align:center">
          <span>{{chartData.big_number}}</span>
          <span v-if="chartData.target">
            {{chartData.target.nice_post_value}}
          </span>
      </h1>
      <div v-if="chartData.target">
          <h2 style="text-align:center">
              {{chartData.target.label_nice}}
          </h2>
          <div style="text-align:center">{{chartData.target.nice_note}}</div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "BigNumber",
        props: ['height','width', 'text_size', 'chartData'],
        computed: {
            style: function () {
                if (this.chartData && this.chartData.hasOwnProperty('color')) {
                  let color = this.chartData.color
                  if (color!=='black') {
                    return 'padding: 20px; color: white;background-color:' + this.chartData.color
                  } else {
                    return 'padding: 20px; color:' + this.chartData.color
                  }
                } else {
                  return ''
                }
            }
        },
        mounted() {
          console.log('chartData received by BigNumber:')
          console.log(this.chartData)
        },
        methods: {
            test() {
                return 'test'
            }
        }
    }
</script>

<style scoped>

</style>